import { render, staticRenderFns } from "./k2SelectStudentJapan.vue?vue&type=template&id=4bdb6799&scoped=true"
import script from "./k2SelectStudentJapan.vue?vue&type=script&lang=js"
export * from "./k2SelectStudentJapan.vue?vue&type=script&lang=js"
import style0 from "./k2SelectStudentJapan.vue?vue&type=style&index=0&id=4bdb6799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb6799",
  null
  
)

export default component.exports